import React from "react";
import PropTypes from "prop-types";

import { Row, Col, Panel, DropdownButton, NavItem } from "react-bootstrap";
import {
  IoPencil,
  IoTrash,
  IoEllipsisVertical,
  IoAddCircle
} from "react-icons/io5";

import { orderBy } from "lodash";

import { formatDate } from "../../../helpers/date";

const ProjectProgressReviewNoteList = ({
  project,
  isMobile,
  onClickAdd,
  onClickEdit,
  onClickDelete
}) => {
  let projectNotesView = (
    <div className="content-wrapper vertical-center sm" style={{ margin: 0 }}>
      <div className="addNoteBtn">
        <span
          role="presentation"
          onKeyDown={() => {}}
          onClick={() => onClickAdd(project)}
        >
          <IoAddCircle /> Add Note
        </span>
      </div>
    </div>
  );

  if (project) {
    const { notes } = project;

    if (notes && notes.length) {
      projectNotesView = (
        <Row>
          <div className="addNoteBtn">
            <span
              role="presentation"
              onKeyDown={() => {}}
              onClick={() => onClickAdd(project)}
            >
              <IoAddCircle /> Add Note
            </span>
          </div>
          {orderBy(notes, "modified_on", "desc").map((note) => {
            const timestamp = formatDate(
              note.created_on,
              !isMobile ? "MM/dd/yyyy hh:mm a" : "MM/dd/yyyy"
            );

            return (
              <Panel bsStyle="info" key={note.id} className="review-note-panel">
                <Panel.Heading>
                  <Row>
                    <Col md={6} xs={6}>
                      <h5>{note.title}</h5>
                    </Col>
                    <Col md={6} xs={6}>
                      <p>
                        <span style={{ marginRight: "10px" }}>
                          {note.created_by.split("@")[0]}
                        </span>
                        •<em style={{ marginLeft: "10px" }}>{timestamp}</em>
                      </p>
                    </Col>
                  </Row>
                </Panel.Heading>
                <Panel.Body>
                  <Col md={11} xs={10}>
                    <blockquote>
                      <div dangerouslySetInnerHTML={{ __html: note.note }} />
                    </blockquote>
                  </Col>
                  <Col md={1} xs={2}>
                    {note.created_by !== "system" && (
                      <div className="actions pull-right">
                        <DropdownButton
                          title={
                            <span>
                              <IoEllipsisVertical />
                            </span>
                          }
                          id="dropdown"
                        >
                          <NavItem
                            onClick={() => onClickEdit(note._id, project)}
                          >
                            <IoPencil />
                            View
                          </NavItem>
                          <NavItem
                            onClick={() => onClickDelete(note._id, project)}
                          >
                            <IoTrash />
                            Delete
                          </NavItem>
                        </DropdownButton>
                      </div>
                    )}
                  </Col>
                </Panel.Body>
              </Panel>
            );
          })}
        </Row>
      );
    }
  }

  return <div>{projectNotesView}</div>;
};

ProjectProgressReviewNoteList.propTypes = {
  project: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
  onClickAdd: PropTypes.func,
  onClickEdit: PropTypes.func,
  onClickDelete: PropTypes.func
};

export default ProjectProgressReviewNoteList;
